// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"70abc768","404":"67819ba7","498":"68e02b5a","921":"f3432bef"}[chunkId] + ".chunk.js";
};